export type TrackingAppName = 'web' | 'windows';

const DEFAULT_TRACKING_APP_NAME: TrackingAppName = 'web';
const WINDOWS_TRACKING_APP_NAME: TrackingAppName = 'windows';
const WINDOWS_SUBDOMAIN_PATTERN = 'windows';

function getTrackingAppName(hostname?: string | null): TrackingAppName {
    if (!hostname) {
        return DEFAULT_TRACKING_APP_NAME;
    }

    if (hostname.toLowerCase().includes(WINDOWS_SUBDOMAIN_PATTERN)) {
        return WINDOWS_TRACKING_APP_NAME;
    }

    return DEFAULT_TRACKING_APP_NAME;
}

function getClientTrackingAppName(): TrackingAppName {
    if (typeof window === 'undefined') {
        return DEFAULT_TRACKING_APP_NAME;
    }

    return getTrackingAppName(window.location.hostname);
}

export { getClientTrackingAppName, getTrackingAppName };
